import { CloseToMaintenanceDays, MaintenanceStatusEnum } from "../status/MaintenanceStatusEnum";

export class ServiceCounter {
    public installationName: string;
    public machineSerialNumber: string;
    public partNumber: string;
    public partName: string;
    public threshold: number;
    public thresholdFound: boolean;
    public counter1: number;
    public timestamp1: Date;
    public counter2: number;
    public timestamp2: Date;
    public counter3: number;
    public timestamp3: Date;
    public countPerDay: number;
    public maxCounter: number;
    public minCounter: number;
    public maxTimestamp: Date;
    public minTimestamp: Date;
    public isForecastingAvailable: boolean;
    public nextMaintenanceDate: Date;
    public lifetimeDays: number;
    public valueMeaning: ServCountValueMeaning;

    get maintenanceRequired(): boolean {
        return this.maxCounter > this.threshold;
    }

    get maintenanceStatus(): MaintenanceStatusEnum {
        // console.log(this);
        // cosa intendo per manutenzione prossima
        let closeToMaintenanceDate = new Date();
        closeToMaintenanceDate.setDate(closeToMaintenanceDate.getDate() + CloseToMaintenanceDays);

        if (this.maintenanceRequired) return MaintenanceStatusEnum.MaintenanceRequired;
        if (this.nextMaintenanceDate != null && new Date(this.nextMaintenanceDate) < new Date(closeToMaintenanceDate)) return MaintenanceStatusEnum.CloseToMaintenance;
        return MaintenanceStatusEnum.Regular;
    }

    public parse(obj: any) {
        if (obj.InstallationName) this.installationName = obj.InstallationName;
        if (obj.MachineSerialNumber) this.machineSerialNumber = obj.MachineSerialNumber;
        if (obj.PartNumber) this.partNumber = obj.PartNumber;
        if (obj.PartName) this.partName = obj.PartName;
        if (obj.Threshold) this.threshold = obj.Threshold;
        if (obj.ThresholdFound != null) this.thresholdFound = obj.ThresholdFound;
        if (obj.Counter1 != null) this.counter1 = obj.Counter1;
        if (obj.Timestamp1) this.timestamp1 = obj.Timestamp1;
        if (obj.Counter2 != null) this.counter2 = obj.Counter2;
        if (obj.Timestamp2) this.timestamp2 = obj.Timestamp2;
        if (obj.Counter3 != null) this.counter3 = obj.Counter3;
        if (obj.Timestamp3) this.timestamp3 = obj.Timestamp3;
        if (obj.CountPerDay) this.countPerDay = obj.CountPerDay;
        if (obj.MaxCounter != null) this.maxCounter = obj.MaxCounter;
        if (obj.MinCounter != null) this.minCounter = obj.MinCounter;
        if (obj.MaxTimestamp) this.maxTimestamp = obj.MaxTimestamp;
        if (obj.MinTimestamp) this.minTimestamp = obj.MinTimestamp;
        if (obj.IsForecastingAvailable != null) this.isForecastingAvailable = obj.IsForecastingAvailable;
        if (obj.NextMaintenanceDate) this.nextMaintenanceDate = obj.NextMaintenanceDate;
        if (obj.LifetimeDays) this.lifetimeDays = obj.LifetimeDays;
        if (Object.values(ServCountValueMeaning).includes(obj.ValueMeaning)) this.valueMeaning = obj.ValueMeaning;
    }
}

export enum ServCountValueMeaning {
    Unknown = 0,
    Generic = 1,
    CoinsNumber = 2,
    ActivationsNumber = 3,
    TimeInSeconds = 4,
}

export function servCountValueMeaningLabel(value: ServCountValueMeaning): string {
    switch (value) {
        case ServCountValueMeaning.Generic:
            return "enum.servCountValueMeaning.Generic";
        case ServCountValueMeaning.CoinsNumber:
            return "enum.servCountValueMeaning.CoinsNumber";
        case ServCountValueMeaning.ActivationsNumber:
            return "enum.servCountValueMeaning.ActivationsNumber";
        case ServCountValueMeaning.TimeInSeconds:
            return "enum.servCountValueMeaning.TimeInSeconds";
        default:
            return "common.unknown";
    }
}
